import {IAlertService} from "./alert.service.interface";
import { NullableString} from "../../types/nullable-types";
import {action, makeObservable, observable,} from "mobx";
import {ServiceBase} from "../service-base";
import {IServiceFactory} from "../service-factory.interface";

export class AlertService extends ServiceBase implements IAlertService {
    constructor(services: IServiceFactory) {
        super(services);
        makeObservable(this, {
            errorMessage: observable.ref,
            closeError: action.bound,
            showError: action.bound,
            blockApp: observable.ref
        });
    }
    errorMessage: NullableString = null;
    blockApp: boolean | undefined = false;

    closeError(): void {
        this.errorMessage = null;
    }

    showError(message: string, blockApp?: boolean): void {
        this.errorMessage = message;
        this.blockApp = blockApp;
    }
}
